document.addEventListener("DOMContentLoaded", () => {
  const UTM_PARAM = "utm_source";
  const CHANNEL_PARAM = "channel";
  const STORAGE_KEY = "formSource";
  const CHECK_ENDPOINT_BASE = window.CHECK_ENDPOINT_BASE || "/api/v2/udb-partners/channels/";
  const EXPIRY_DAYS = 14;
  const REGISTRATION_HOSTS = [
    "test-partner.ingdlabiznesu.pl",
    "partner.ingdlabiznesu.pl",
    "udb.desygna.pl"
  ];
  const REGISTRATION_PATHS = [
    "/registration",
    "/partner/formularz",
    "/partnerzy/formularz"
  ];

  function getQueryParam(name) {
    const params = new URLSearchParams(window.location.search);
    return (params.get(name) || "").trim();
  }

  async function fetchWithTimeout(url, opts = {}, timeoutMs = 5000) {
    const controller = new AbortController();
    const id = setTimeout(() => controller.abort(), timeoutMs);

    try {
      return await fetch(url, { ...opts, signal: controller.signal, credentials: "same-origin" });
    } finally {
      clearTimeout(id);
    }
  }

  async function isSourceAllowed(source) {
    if (!source) return false;

    try {
      const res = await fetchWithTimeout(
        `${CHECK_ENDPOINT_BASE}${encodeURIComponent(source)}`,
        { method: "HEAD" },
        5000
      );

      return res.status === 200;
    } catch {
      return false;
    }
  }

  function setFormSource(source) {
    const expiry = Date.now() + EXPIRY_DAYS * 24 * 60 * 60 * 1000;
    const data = JSON.stringify({ value: source, expiry });

    localStorage.setItem(STORAGE_KEY, data);
  }

  function getFormSource() {
    const raw = localStorage.getItem(STORAGE_KEY);

    if (!raw) return null;

    try {
      const { value, expiry } = JSON.parse(raw);

      if (Date.now() > expiry) {
        localStorage.removeItem(STORAGE_KEY);
        return null;
      }

      return value;
    } catch {
      localStorage.removeItem(STORAGE_KEY);
      return null;
    }
  }

  function isRegistrationUrl(url) {
    const normalizedPath = url.pathname.replace(/\/$/, "");
    const isAllowedHost = REGISTRATION_HOSTS.includes(url.hostname) || url.origin === window.location.origin;

    return isAllowedHost && REGISTRATION_PATHS.includes(normalizedPath);
  }

  function addChannelToRegistrationLinks(channel) {
    if (!channel) return;

    document.querySelectorAll("a[href]").forEach((link) => {
      try {
        const url = new URL(link.getAttribute("href"), window.location.href);

        if (!isRegistrationUrl(url)) {
          return;
        }

        url.searchParams.set(CHANNEL_PARAM, channel);
        link.setAttribute("href", url.toString());
      } catch {
        // Niepoprawne lub specjalne href-y pomijamy.
      }
    });
  }

  (async () => {
    const utmSource = (getQueryParam(UTM_PARAM) || "").toLowerCase();

    if (!utmSource) {
      addChannelToRegistrationLinks(getFormSource());
      return;
    }

    const allowed = await isSourceAllowed(utmSource);

    if (allowed) {
      setFormSource(utmSource);
      addChannelToRegistrationLinks(utmSource);
      return;
    }
    addChannelToRegistrationLinks(getFormSource());
  })();
});
